import React from 'react';
import "./DropzoneBody.scss";

const DropzoneBody = ({
  getRootProps,
  getInputProps,
  open,
}: {
  getRootProps: () => object;
  getInputProps: () => object;
  open: () => void;
}) => (
  <>
    <div {...getRootProps()} className="hid_dropzone">
      <input {...getInputProps()} />
      <span className="hid_dropzone_icon">📂</span>
      <div className="hid_dropzone_main">
        Drop your CSV here, or{' '}
        <button className="hid_dropzone_link" onClick={open}>
          click to browse
        </button>
      </div>
      <div className="hid_dropzone_sub">Accepts .csv files only</div>
    </div>
  </>
);

export default DropzoneBody;